<template>
    <div class="robot-select-content">
        <common-select-panel
            ref="selectPanel"
            clazz="robot-select-panel"
            :value="currentValue"
            :search-placeholder="searchPlaceHolder"
            :multiple="true"
            :select-count-btn="true"
            :index="index"
            :count="count"
            :maps="{ value: 'id', text: 'name' }"
            :select-required="false"
            :multiple-level="true"
            :list-function="fetchList"
            @confirm="handleChange"
        >
            <template
                slot="trigger"
            >
                <span>{{ hasValue ? showTxt() : $t('请选择') }}</span><v-icon name="arrow_dropdown" />
            </template>
        </common-select-panel>
    </div>
</template>

<script>
import CommonSelectPanel from '@/components/market-common-select-panel';
/**
 * @page 语音机器人选择器
 */
export default {
  name: 'RobotSelect',

  components: {
    CommonSelectPanel,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    const currentValue = this.value || [];
    return {
      // 搜索文案
      searchPlaceHolder: this.$t('语音机器人名称'),
      // 选中id list
      currentValue,
      // 选中数据
      selectedList: [],
      valid: true,
      // 请求页码
      index: 1,
      // 请求数量
      count: 100,
    };
  },
  computed: {
    // 有选中项
    hasValue() {
      return this.currentValue && this.currentValue.length > 0;
    },
  },
  watch: {
    value: {
      handler(newValue) {
        // 将值转换为id list
        this.currentValue = newValue && newValue.length ? this.transToArrID(newValue) : [];
      },
      immediate: true,
    },
  },

  mounted() {
    this.onChange(this.value);
  },

  methods: {
    /**
         * @desc 请求数据
         * @param {Number} index - 页码
         * @param {Number} count - 数量
         * @param {String} searchValue - 搜索文字
         */
    fetchList(index, count, searchValue) {
      const params = {
        index,
        count,
        keyword: '',
      };
      // 搜索时，用搜索的url即可
      if (searchValue) {
        params.keyword = searchValue;
      }
      return this.$ajax.gatewayPost('/call/robots/getAllYunxiaoweiRobotList', { params })
        .then((res) => {
          res.data.records.map((item) => {
            const { id, name } = item || {};
            return {
              id,
              name,
            };
          });
          return res.data.records || [];
        });
    },
    /**
         * @desc 确认选中
         * @param {Object} value - 选中数据
         */
    handleChange(value) {
      this.onChange(value.options);
    },
    /**
         * @desc 更改数据
         * @param {Object} value - 选中机器人数据
         */
    onChange(value) {
      this.valid = true;
      this.selectedList = value && value.length ? value : [];
      this.showTxt();
      const ruleData = {
        operation: 'arrayInclude',
        name: this.optionInfo.value,
        type: 'array',
        value: JSON.stringify(value),
      };
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: this.getValidate(),
      });
    },
    /**
         * @desc 展示文字
         */
    showTxt() {
      const showArr = [];
      const groupArr = [];

      this.selectedList.forEach((item) => {
        groupArr.push(item);
      });

      if (groupArr.length > 0) {
        if (groupArr.length > 1) {
          showArr.push(this.$t('{name}等{count}个机器人', { name: groupArr[0].name, count: groupArr.length }));
        } else {
          showArr.push(groupArr[0].name);
        }
      }
      return showArr[0];
    },
    /**
         * @desc 转换为id list
         * @param {Array} arr
         */
    transToArrID(arr) {
      const list = [];
      arr.map(item => list.push(item.id));
      return list;
    },
    getValidate() {
      return !!(this.currentValue.length && this.currentValue.length > 0);
    },
    validate() {
      this.valid = this.getValidate();
      return this.valid;
    },
  },
};
</script>

<style scoped lang="less">
.robot-select-content {
    display: inline-block;
    line-height: 30px;
    font-size: 14px;
    cursor: pointer;

    &.is-placeholder {
        color: #a8abb3;
    }

    .v-icon {
        color: #a8abb3;
        margin-left: 5px;
        width: 10px;
        height: 10px;
    }
}
</style>
<style lang="less">
.robot-select-panel {
  .selectCount-button {
    right: 157px !important;
  }
}
</style>
